export default __webpack_public_path__ + "static/media/payment.f921a281.svg";